import { IconName } from '~/src/components/generic/PhosphorIcons'

export type ItemMenu = {
  iconName: IconName
  label: string
  action: ActionEnum
}

export enum ActionEnum {
  ReportIssue = 'REPORT_AN_ISSUE',
  Settings = 'SETTINGS',
  Logout = 'LOG_OUT',
}
